import { useMemo } from "react";
import type { TripDto } from "@tc/shared";
import { ChatPane, type ChatPaneHeader, type ChatSource } from "./ChatPane";
import { messagingApi } from "./api";

/**
 * The per-trip conversation between the club and TC (TW-3453) — embedded on the trip detail
 * Messages tab for both audiences (the club's proposal view and the back-office event surface reach
 * the same shared, RLS-scoped thread). A thin wrapper that points the reusable {@link ChatPane} at
 * this trip's thread endpoints. An optional `header` lets a caller (e.g. the club enquiry view,
 * where the thread sits inline below the trip details) label the pane.
 */
export function MessagesTab({ trip, header }: { trip: TripDto; header?: ChatPaneHeader }) {
  const source = useMemo<ChatSource>(
    () => ({
      load: () => messagingApi.getTripThread(trip.id),
      post: (body) => messagingApi.postTrip(trip.id, body),
      markRead: () => messagingApi.markTripRead(trip.id),
    }),
    [trip.id],
  );
  return <ChatPane source={source} sourceKey={`trip:${trip.id}`} header={header} />;
}
